import { Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from './context/session-provider';
import { WorkspaceProvider } from './context/workspace-provider';
import { ToastProvider } from './components/ui/toast-provider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false, // Don't refetch when tab switches
    },
  },
});

const Providers = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <WorkspaceProvider>
          <ToastProvider>
            <Outlet />
          </ToastProvider>
        </WorkspaceProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
};

export default Providers;
